import { combineReducers } from 'redux'
import { router5Reducer } from 'redux-router5'
import { reducer as formReducer } from 'redux-form'

import { quoteReducer } from './quote-reducer'
import { errorReducer } from './error-reducer'

export const rootReducer = combineReducers({
  router: router5Reducer,
  form: formReducer,
  quotes: quoteReducer,
  error: errorReducer
})
